import React, {useEffect, useState} from 'react';
import StatisticApi from "../API/StatisticApi";
import {MainDiv} from "./StatisticDesign";
import StatisticTable from "./StatisticTable/StatisticTable";
import HouseSelection from "./HouseSelection";
import useStore from "../Store";

const Statistic = () => {
    const Houses=useStore((state)=>state.Houses.Location1);
    const [selectedHouse, setSelectedHouse]=useState("W")
    const [Works, setWorks]=useState(null)
    const [WorkTypes, setWorkTypes]=useState(null)
    const [Dates, setDates]=useState(null)
    const [Data, setData]=useState(null)

    function regroupData(Data){
        function BaseDateToEU(BaseDate){
            const arr=BaseDate.split('-')
            const Day=arr[2]
            const Month=arr[1]
            const Year=arr[0]
            return Day+"."+Month+"."+Year;
        }
        let Dates=[];
        let RegroupedData={}
        Data.map(GoAroundElement=>{
            const Date=BaseDateToEU(GoAroundElement.go_around_date.split('T')[0])
            Dates.push(Date)
            for(const House in GoAroundElement.go_around_data){
                RegroupedData[House]??={}
                const frontId=GoAroundElement.go_around_data.frontId
                console.log(frontId)
                for(const Floor in GoAroundElement.go_around_data[House].Floors) {
                    RegroupedData[House][Floor]??={ProgressWorks:{}}
                    for(const ProgressWorkType in GoAroundElement.go_around_data[House].Floors[Floor].ProgressWorkTypes) {
                        RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]??={}
                        GoAroundElement.go_around_data[House].Floors[Floor].ProgressWorkTypes[ProgressWorkType].ProgressWorks.map(ProgressWork => {
                            let ProgressWorkName;
                            RegroupedData[House][Floor].ProgressWorks[ProgressWorkType][ProgressWork.ProgressWorkName]??=[]
                            if(Number(ProgressWork.Percent) != 0)
                            RegroupedData[House][Floor].ProgressWorks[ProgressWorkType][ProgressWork.ProgressWorkName].push({
                                    Data: Date,
                                    Percent: ProgressWork.Percent,
                                    frontId:frontId
                                })
                        })
                       Object.entries(RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]).forEach(([ProgressWork, Array])=>{
                            if(Array.length === 0) {
                                delete RegroupedData[House][Floor].ProgressWorks[ProgressWorkType][ProgressWork]
                            }
                        })
                        if(Object.keys(RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]).length === 0) delete RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]
                    }
                    if(Object.keys(RegroupedData[House][Floor].ProgressWorks).length === 0) delete RegroupedData[House][Floor]
                }
                if(Object.keys(RegroupedData[House]).length === 0) delete RegroupedData[House]
            }
        })
        return {Dates:Dates, Data:RegroupedData}
    }

    function regroupWorks(InputWorks){
        let WorkTypes={}, Works={}
        for(const WorkType in InputWorks){
            WorkTypes={...WorkTypes, [InputWorks[WorkType].WorkTypeId]:WorkType}
            InputWorks[WorkType].Works.map(Work=>{
                Works={...Works, [Work.WorkId]:Work.WorkName}
            })
        }
        return {WorkTypes:WorkTypes, Works:Works}
    }
    useEffect(() => {
        StatisticApi.getGoAroundData()
            .then(res=>{
                const temp=regroupData(res.Data)
                 console.log(res, temp)
                setDates(temp.Dates)
                setData(temp.Data)
             })
        StatisticApi.getWorks()
            .then(res=>{
                const {TempWorks, TempWorkTypes}=regroupWorks(res.WorkTypes)
                setWorkTypes(TempWorkTypes)
                setWorks(TempWorks)
            })
    }, []);
    // console.log(Dates);
    return (

            Dates??Data?
            <MainDiv>
                <HouseSelection
                    houses={Houses}
                    selectedHouse={selectedHouse}
                    setSelectedHouse={setSelectedHouse}
                />
                <StatisticTable
                    Data={Data}
                    selectedHouse={selectedHouse}
                    Dates={Dates}
                />
            </MainDiv>
            :""

    );
};

export default Statistic;

